module.exports = __webpack_public_path__ + "img/hr-tree-06-c-trunk.5c88766d.png";